import { useEffect } from "react";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import ReactGA from "react-ga4";

function Home() {
    useEffect(() => {
        document.title = "Home - David Adkins";
        if (process.env.NODE_ENV !== "test") {
            ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search });
        }
    });

    return (
        <Paper elevation={3} square={true} sx={{ margin: "40px 0", padding: "25px" }}>
            I really don't have a lot to say here. I wanted to brush up on React and Node,
            wanted to learn about writing Jest tests and deploying sites through CI to GH Pages.
            Now I have my own site, it's ugly, but it's mine. I may update, I may not, time will tell.
            <Typography component={"span"} variant={"body2"}>
                Here's a quick intro on my interests:
                <ul>
                    <li>Front End Dev (React, JS, Node)</li>
                    <li>Back End Dev (Golang, Python, PHP)</li>
                    <li>Machine Learning (Reinforcement Learning, CNN, GANs)</li>
                    <li>Responsible AI (Interpretability, Robustness, Explainability)</li>
                </ul>
            </Typography>
            <Typography component={"span"} variant={"body2"}>
                I want some cards here for some of my personal projects.
            </Typography>
        </Paper>
    );
}

export default Home;
